import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'app/store';
import {
  onRowToggled,
  selectIsRowOpen
} from './conversion-influence/conversion-influence-table.slice';
import { RowToggledPayload } from './types/insights-table.types';

interface InsightsTableAccordionProps {
  rowId: string;
  isHidden: boolean;
}

const InsightsTableAccordion = ({
  rowId,
  isHidden
}: InsightsTableAccordionProps) => {
  const dispatch = useDispatch();
  const isOpen = useSelector((state: RootState) =>
    selectIsRowOpen(state, rowId)
  );

  const onToggleRow = () => {
    if (isHidden) {
      return;
    }

    const payload: RowToggledPayload = {
      rowId
    };

    dispatch(onRowToggled(payload));
  };

  return (
    <>
      <button
        onClick={onToggleRow}
        className={`text-xs ${isHidden ? 'opacity-0 cursor-default' : ''}`}
        id={`${rowId}-table-accordion`}
      >
        <i
          className={`ra-icons-generic-down-arrow block transition-all ${
            isOpen ? 'rotate-0' : '-rotate-90'
          }`}
        ></i>
      </button>
    </>
  );
};
export default InsightsTableAccordion;
